import { render, staticRenderFns } from "./UserFirms.vue?vue&type=template&id=25bf2251&scoped=true"
import script from "./UserFirms.vue?vue&type=script&lang=js"
export * from "./UserFirms.vue?vue&type=script&lang=js"
import style0 from "./UserFirms.vue?vue&type=style&index=0&id=25bf2251&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bf2251",
  null
  
)

export default component.exports